export default {"src":"/_next/static/media/discountGreen_40.00635e5e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};